import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md iodine-references-header" }
const _hoisted_2 = { class: "q-gutter-sm" }
const _hoisted_3 = { class: "row references-search-bar" }
const _hoisted_4 = { class: "col-5 references-search-bar-item" }
const _hoisted_5 = { class: "col-7 iodine-padding-left-sm references-search-bar-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "iodine-padding-right-sm" }, "20 Results", -1)

import {ref} from 'vue';
    import { ReferencesBook } from 'src/services/TrucodeReferencesService';
    import { TrucodeReferencesService } from 'src/services/TrucodeReferencesService';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesHeader',
  emits: ["referencesOptionChanged", "bookChanged", "searchTextChanged", "searchAction"],
  setup(__props, { emit: __emit }) {

const referencesOption = ref('search');

  const searchOption = ref(null);
  const browseOption = ref(null);
  const text = ref('');

  const emit = __emit

    function bookChanged(referencesBook : ReferencesBook) {
      emit('bookChanged', referencesBook);
    }

  function referencesOptionChanged(value) {
      if (value === 'search') {
          searchOption.value = 'Make Selection';
      } else {
          browseOption.value = 'Make Selection';
      }

      emit('referencesOptionChanged', value)
  }

return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_radio, {
        modelValue: referencesOption.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((referencesOption).value = $event)),
          referencesOptionChanged
        ],
        val: "search",
        label: "Search"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_radio, {
        modelValue: referencesOption.value,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((referencesOption).value = $event)),
          referencesOptionChanged
        ],
        val: "browse",
        label: "Browse"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (referencesOption.value === 'search')
            ? (_openBlock(), _createBlock(_component_q_select, {
                key: 0,
                outlined: "",
                dense: "",
                modelValue: searchOption.value,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((searchOption).value = $event)),
                  bookChanged
                ],
                options: _unref(TrucodeReferencesService).getInstance().getSearchOptions(),
                "option-label": "title",
                "option-value": "id",
                label: "Book",
                class: "search-references-book",
                for: "search-references-book"
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (referencesOption.value === 'browse')
            ? (_openBlock(), _createBlock(_component_q_select, {
                key: 1,
                outlined: "",
                dense: "",
                modelValue: browseOption.value,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((browseOption).value = $event)),
                  bookChanged
                ],
                options: _unref(TrucodeReferencesService).getInstance().getBrowseOptions(),
                "option-label": "title",
                "option-value": "id",
                label: "Book",
                for: "browse-references-book",
                class: "browse-references-book"
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_input, {
            dense: "",
            outlined: "",
            modelValue: text.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((text).value = $event)),
            label: "Search for a term or code...",
            class: "references-search",
            for: "references-search",
            disable: referencesOption.value !== 'search'
          }, {
            append: _withCtx(() => [
              _hoisted_6,
              (text.value === '')
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "search"
                  }))
                : (_openBlock(), _createBlock(_component_q_icon, {
                    key: 1,
                    name: "clear",
                    class: "cursor-pointer",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (text.value = ''))
                  }))
            ]),
            _: 1
          }, 8, ["modelValue", "disable"])
        ])
      ])
    ])
  ]))
}
}

})